export const priceColumnNames = [
    'products_total',
    'payments_total',
    'debt',
    'order_price',
    'products_total',
    'case_total',
]